<template>
  <div class="container">
    <div class="row">
      <div class="col">
        <h3 class="text-center">
          <span style="padding: 0 12px;border-left:1px solid;border-right:1px solid;">{{ $t('picture.title') }}</span>
        </h3>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <b-breadcrumb style="background-color: transparent;">
          <b-breadcrumb-item :to="{ name: 'index' }">{{ $t('index.title') }}</b-breadcrumb-item>
          <b-breadcrumb-item>{{ $t('picture.title') }}</b-breadcrumb-item>
          <b-breadcrumb-item>{{ $t('picture.detail.title') }}</b-breadcrumb-item>
        </b-breadcrumb>
      </div>
    </div>
    <div class="row" v-if="picture_previewable_efile">
      <div class="col">
        <b-img :src="picture_previewable_efile.url" fluid center></b-img>
      </div>
    </div>
    <div class="row">
      <div class="col"><hr></div>
    </div>
    <div class="row">
      <div class="col">
        <picture-info :picture="picture"></picture-info>
        <b-button-toolbar>
          <b-button-group>
            <b-button
              variant="primary"
              @click="addPictureToApplicationList(picture)"
              :disabled="picture.in_stock == 'N'"
            >{{ picture.in_stock == 'N' ? $t('picture.button.application.label.out-of-stock') : $t('picture.button.application.label.in-stock') }}</b-button>
            <b-button variant="info" @click="showDownloadList(picture)">{{ $t('picture.button.download.label') }}</b-button>
          </b-button-group>
        </b-button-toolbar>
        <dharma-application-form ref="application_form"></dharma-application-form>
        <dharma-grant-susp-msg-modal id="dharma-grant-susp-msg-modal"></dharma-grant-susp-msg-modal>
      </div>
    </div>
    <div class="row">
      <div class="col"><hr></div>
    </div>
    <div class="row">
      <div class="col">
        <h5>{{ $t('picture.detail.list.efile.heading') }}</h5>
        <picture-efile-list
          :downloadable_efile="picture_downloadable_efile"
          :printable_efile="picture_printable_efile"
        ></picture-efile-list>
      </div>
    </div>
    <div class="row">
      <div class="col"><hr></div>
    </div>
    <div class="row">
      <div class="col">
        <b-button :to="{ name: 'pictures' }" variant="primary" block>{{ $t('picture.detail.button.view-more.label') }}</b-button>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from 'vue'

import { BreadcrumbPlugin } from 'bootstrap-vue'
import { ButtonGroupPlugin } from 'bootstrap-vue'
import { ButtonPlugin } from 'bootstrap-vue'
import { ButtonToolbarPlugin } from 'bootstrap-vue'
import { IconsPlugin } from 'bootstrap-vue'
import { ImagePlugin } from 'bootstrap-vue'
import { ModalPlugin } from 'bootstrap-vue'

import ApplicationList from '@/components/forms/dharma-application-form/ApplicationList'
import DharmaApplicationForm from '@/components/forms/dharma-application-form/DharmaApplicationForm'
import PictureEfileList from '@/components/lists/PictureEfileList'
import PictureInfo from '@/components/info/PictureInfo'
import DharmaGrantSuspMsgModal from '@/components/modals/DharmaGrantSuspMsgModal'

import i18n from '@/plugins/i18n.js'

import PictureApiService from '@/services/budaedu-api-services/picture-api-service.js'

Vue.use(BreadcrumbPlugin)
Vue.use(ButtonGroupPlugin)
Vue.use(ButtonPlugin)
Vue.use(ButtonToolbarPlugin)
Vue.use(IconsPlugin)
Vue.use(ImagePlugin)
Vue.use(ModalPlugin)

Vue.use(ApplicationList)

Vue.use(PictureApiService)

export default {
  i18n,
  name: 'picture',
  props: {
    id: {
      type: Number,
      require: true
    }
  },
  data() {
    return {
      picture: null,
      picture_previewable_efile: null,
      picture_downloadable_efile: null,
      picture_printable_efile: null
    }
  },
  methods: {
    addPictureToApplicationList(picture) {
      this.$dharmaApplicationList.addItem({
        code: picture.code,
        name: picture.chinese_name,
        type: picture.type,
        quantity: picture.quantity,
        apply_type: 'picture'
      })
      
      this.$bvModal.show(`application-success-message-${this.$refs[`application_form`].uuid}`)

      // this.showDharmaGrantSuspensionMessage()
    },
    showDharmaGrantSuspensionMessage() {
      this.$bvModal.show('dharma-grant-susp-msg-modal')
    },
    async setPicture() {
      const item = await this.$pictureApiService.getById(this.id)
      this.picture = item.data
      this.picture_previewable_efile = await this.$pictureApiService.getPreviewableEfile(this.picture)
      this.picture_downloadable_efile = await this.$pictureApiService.getDownloadableEfile(this.picture)
      this.picture_printable_efile = await this.$pictureApiService.getPrintableEfile(this.picture)
    }
  },
  async created() {
    //alert(`Vue version : ${Vue.version}`);
    await this.setPicture()
  },
  components: {
    DharmaApplicationForm,
    DharmaGrantSuspMsgModal,
    PictureEfileList,
    PictureInfo
  },
  metaInfo() {
    let title = ''
    if (this.picture) {
      switch (this.$i18n.locale) {
        case 'tw':
          title = this.picture.chinese_name
          break
        case 'en':
          title = this.picture.english_name
          break
        default:
          title = this.$t('picture.detail.title')
          break
      }
    }
    return {
      title: title,
      meta: [{
        vmid: 'description',
        name: 'description',
        content: ''
      }]
    }
  }
};
</script>